import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/node-js': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M224 508c-6.7 0-13.5-1.8-19.4-5.2l-61.7-36.5c-9.2-5.2-4.7-7-1.7-8 12.3-4.3 14.8-5.2 27.9-12.7 1.4-0.8 3.2-0.5 4.6 0.4l47.4 28.1c1.7 1 4.1 1 5.7 0l184.7-106.6c1.7-1 2.8-3 2.8-5v-213.2c0-2.1-1.1-4-2.9-5.1l-184.6-106.5c-1.7-1-4-1-5.7 0l-184.5 106.6c-1.8 1-2.9 3-2.9 5.1v213.1c0 2 1.1 4 2.9 4.9l50.6 29.2c27.5 13.7 44.3-2.4 44.3-18.7v-210.4c0-3 2.4-5.3 5.4-5.3h23.4c2.9 0 5.4 2.3 5.4 5.3v210.5c0 36.6-20 57.6-54.7 57.6-10.7 0-19.1 0-42.5-11.6l-48.4-27.9c-12-6.9-19.4-19.8-19.4-33.7v-213.1c0-13.8 7.4-26.8 19.4-33.7l184.5-106.6c11.7-6.6 27.2-6.6 38.8 0l184.7 106.7c12 6.9 19.4 19.8 19.4 33.7v213.1c0 13.8-7.4 26.7-19.4 33.7l-184.7 106.6c-5.9 3.4-12.6 5.2-19.4 5.2zM373.1 297.9c0 40.2-33.6 63.3-92 63.4-80.9 0-97.8-37.1-97.8-68.2 0-2.9 2.3-5.3 5.3-5.3h23.9c2.7 0 4.9 1.9 5.3 4.5 3.6 24.3 14.3 36.6 63.2 36.6 38.9 0 55.5-8.8 55.5-29.4 0-11.9-4.7-20.8-65.2-26.7-50.5-5-81.8-16.2-81.8-56.6 0-37.3 31.4-59.5 84.1-59.5 59.2 0 88.5 20.5 92.2 64.6 0.1 1.5-0.4 3-1.4 4.1-1 1.1-2.4 1.7-3.9 1.7h-24c-2.5 0-4.7-1.8-5.2-4.2-5.8-25.6-19.8-33.8-57.7-33.8-42.5 0-47.4 14.8-47.4 25.9 0 13.4 5.8 17.3 63.2 24.9 56.7 7.5 83.7 18.1 83.7 58z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/node-js.js
// module id = 942
// module chunks = 0